import {DatePicker, Form, FormInstance, Input, InputNumber, Modal, Select, Switch} from "antd";
import React from "react";
import Locale from "../../../../core/locale/locale";
import TextArea from "antd/es/input/TextArea";
import {AssetFormData} from "../type/asset-category.types";
import {Asset_Status} from "../../../../constant/constant";

interface AssetModalProps {
    createAssetModal: boolean;
    editMode: boolean;
    createAssetForm: FormInstance;
    handleAssetReset: () => void;
    handleAssetSubmit: (values: AssetFormData) => Promise<void>;
}

const AssetModal = (props: AssetModalProps) => {
    const isDisable = props.editMode;

    return (
        <Modal
            className={'hrms-app create-asset-modal'}
            title={props.editMode ? "Edit Asset" : "Add Asset"}
            open={props.createAssetModal}
            onCancel={props.handleAssetReset}
            onOk={async () => {
                try {
                    const values = await props.createAssetForm.validateFields();
                    props.handleAssetSubmit(values);
                } catch (e) {
                    console.log(e)
                }
            }}
        >
            <Form
                form={props.createAssetForm}
                layout="vertical"
            >
                <div className="asset-modal__row">
                    <Form.Item
                        label="Asset Code"
                        name="assetCode"
                        rules={[
                            {required: true, message: "Please enter asset code"},
                            {
                                pattern: /^\S+$/,
                                message: "Spaces are not allowed"
                            }
                        ]}
                    >
                        <Input placeholder="Enter Asset Code"/>
                    </Form.Item>

                    <Form.Item label="Brand Name" name="brandName">
                        <Input placeholder="Enter Brand Name"/>
                    </Form.Item>
                </div>

                <div className="asset-modal__row">
                    <Form.Item label="Purchase Date" name="purchaseDate">
                        <DatePicker format={Locale.displayDate}/>
                    </Form.Item>

                    <Form.Item label="Purchase Cost" name="purchaseCost">
                        <InputNumber placeholder={"Enter Purchase Cost"} style={{width: "100%"}}/>
                    </Form.Item>
                </div>

                <div className="asset-modal__row">
                    <Form.Item label="Warranty Date" name="warrantyDate">
                        <DatePicker format={Locale.displayDate}/>
                    </Form.Item>

                    <Form.Item label="Manufacturing Date" name="manufacturingDate">
                        <DatePicker format={Locale.displayDate}/>
                    </Form.Item>
                </div>

                <div className="asset-modal__row">

                    <Form.Item
                        label="Returnable?"
                        name="isReturnable"
                        valuePropName="checked"
                        initialValue={false}
                        rules={[{
                            required: true,
                            message: "Please check if required!"
                        }]}
                    >
                        <Switch checkedChildren="Yes" unCheckedChildren="No"/>
                    </Form.Item>

                    <Form.Item
                        label={"Asset Status"}
                        name={"status"}
                        rules={[{required: true, message: "Please select status"}]}
                    >
                        <Select
                            disabled={isDisable}
                            placeholder={'Select Asset Status'}>
                            {(Object.keys(Asset_Status) as Array<keyof typeof Asset_Status>).map((key) =>
                                <Select.Option value={key} key={key}>
                                    {Asset_Status[key]}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                </div>

                <Form.Item label={"Specification"} name={"specification"}>
                    <TextArea placeholder={"Enter Specification"}/>
                </Form.Item>

                <Form.Item label={"Comment"} name={"comments"}>
                    <TextArea placeholder={"Enter Comment"}/>
                </Form.Item>

            </Form>
        </Modal>
    )
}

export default AssetModal;
